module.exports = __webpack_public_path__ + "static/img/2.5d77269.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/zh/2.png
// module id = PCQP
// module chunks = 0